// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","loading":"styles_loading__aurD7","footer":"styles_footer__lYAES"};